import { Pipe, PipeTransform } from '@angular/core';
import {
    DateInputInspectionItem,
    InspectionItemBase,
    InspectionItemResultType,
    InspectionItemType,
    NumericRangeInspectionItem,
    TrafficLightInspectionItem,
} from '@raptor-fe/core';

/**
 * Returns a Bootstrap badge CSS class for an inspection item based on its result.
 * TrafficLight, NumericRange, and DateInput items with a set resultId produce a non-empty class;
 * a DateInput carries one only when its binding derives it (an overdue next service date).
 */
@Pipe({ name: 'inspectionItemBadgeClass' })
export class InspectionItemBadgeClassPipe implements PipeTransform {
    transform(value: InspectionItemBase): string {
        switch (value.itemType) {
            case InspectionItemType.TrafficLight:
            case InspectionItemType.NumericRange:
            case InspectionItemType.DateInput: {
                const { resultId } = value as TrafficLightInspectionItem | NumericRangeInspectionItem | DateInputInspectionItem;
                switch (resultId) {
                    case InspectionItemResultType.Pass:
                        return 'bg-success';
                    case InspectionItemResultType.Warning:
                        return 'bg-warning text-dark';
                    case InspectionItemResultType.Fail:
                        return 'bg-danger';
                    default:
                        return '';
                }
            }
            default:
                return '';
        }
    }
}
